import React from 'react'
import css from './style.scss'
import EyeIcon from 'react-icons/lib/md/remove-red-eye'
import WarningIcon from 'react-icons/lib/md/warning'
import moment from 'moment';
import store from 'utils/store';
import {push} from 'react-router-redux';
import numbers from 'shared/numbers'
import cn from 'classnames'
import CheckIcon from 'react-icons/lib/md/check'
import ClearIcon from 'react-icons/lib/md/close'

const Checkbox = (props) => {
  let Icon=props.icon==="trash" ? ClearIcon : CheckIcon
  return (
    <button className={css.checkbox}>
      <Icon size={16} />
    </button>
  )
}


class Story extends React.Component{
  handleClick(e){
    if(this.props.select){
      e.stopPropagation()
      e.preventDefault()
      this.props.onSelect(this.props.id, !this.props.selected)
    }else{
      store.dispatch(push(window.location.pathname+(this.props.baseName ? this.props.baseName+"/" : "/") +this.props.id))
    }
  }
  render(){
    const style={"backgroundImage":"url('"+this.props.thumb+"')"}
    return (
        <div onClick={this.handleClick.bind(this)} className={cn(css.story, this.props.select ? css.select : "", this.props.selected ? css.selected : "") }>
          <div className={css.storyImageContainer} style={style}>
            <div className={css.storyImage}>
            <div className={css.storyInfo}>
              <div className={css.topBar}>
              {this.props.select && <Checkbox icon={this.props.selectIcon} selected={this.props.selected}/>}
              <div className={css.time}>
                {this.props.fullDate && <span>{moment(this.props.posted_at).format('DD MMM')}</span>}
                <span className={css.right}>{moment(this.props.posted_at).format('HH:mm')}</span>
              </div>
              </div>
              <div className={css.footer}>
                <div className={css.views}>
                <EyeIcon size={16}/>{this.props.insights.impressions===-1 ? "-" : numbers.abbr(this.props.insights.impressions)}
                {this.props.sync.error && <WarningIcon size={16}/>}
                </div>
              </div>
            </div>
            </div>
          </div>
        </div>
    )
  }
}

export default Story;



// WEBPACK FOOTER //
// ./src/components/account_page/stories/list/story.js